/**
 * A printable document, as DATA.
 *
 * Master Specification section 24 asks for an Aeris Print Engine that grows to
 * cover ESC/POS at 58mm and 80mm, A4, PDF, labels and barcodes, across nine
 * kinds of document — and says in one line what most of the design follows
 * from: **do not depend on `window.print()` as the desktop solution.**
 *
 * `window.print()` hands a browser's rendering of a web page to whatever the
 * operating system's print dialog does with it. On a thermal printer that is a
 * page of A4 with margins nobody asked for, a dialog between the operator and
 * the paper, and no way to cut, open a drawer, or print a barcode the scanner
 * can read back. It is also the only option a browser has, which is why it
 * cannot be the architecture.
 *
 * So a document here is a list of BLOCKS with no idea how they will be drawn.
 * A renderer turns blocks into ESC/POS bytes, or plain text, or HTML; a
 * transport puts them somewhere. The three are separable, and only the first
 * has business rules in it:
 *
 * ```
 *   receiptFor(sale) ──▶ PrintDocument ──▶ encodeEscPos() ──▶ transport
 *                                     └──▶ renderText()   ──▶ a preview, a test
 *                                     └──▶ renderHtml()   ──▶ the browser
 * ```
 *
 * The point of the split is that the RECEIPT — what a customer is handed and
 * what a shop is audited on — is decided once, in one function, with tests,
 * and does not change because the shop bought a different printer.
 *
 * ## Why the width lives in the renderer, not here
 *
 * A block says "these two things sit on opposite ends of a line". Whether that
 * line holds 32 or 48 characters is a fact about the paper. A document that
 * baked in 48 would silently truncate every 58mm receipt, and the truncation
 * would land on the price, because the price is on the right.
 */
export const PRINT_FONT_FAMILIES = ['consolas', 'courier', 'arial'];
export const PRINT_FONT_SIZES = ['normal', 'large', 'extra'];
/** Quanto a letra estica para cima em cada tamanho. */
export const PRINT_FONT_SCALE = {
    normal: 1,
    large: 1.35,
    extra: 1.7,
};
//# sourceMappingURL=document.js.map